import { makeQuery } from 'shared/utilities';
import { TinetsConfigModels } from "shared/models";

type ResponseType = TinetsConfigModels;

export const tinetsConfigQuery = async function () {
    return await makeQuery<ResponseType>('/tinets/config');
}
